// extracted by mini-css-extract-plugin
export default {"wrap":"eH-z","fullWidth":"fH-z","hideOnDesktop":"gH-z","content":"hH-z","hasOpenedNav":"iH-z","crumbsList":"jH-z","dropdownsWrap":"kH-z"};